import * as HOSTS from './hosts.js';
import * as MATCHERS from './matchers.js';
import { dev } from './conf/config.dev.js';

export const getConfig = (env) => {
    switch (env) {
        case HOSTS.DEV:
            const api_domain = getApiHost(env);
            return dev(api_domain);
        default:
            return {};
    }
};

const getApiHost = () => {
    const host = window.location.hostname;
    const match = host.match(MATCHERS.DEV);
    return match[1];
};
